export default __webpack_public_path__ + "static/media/sslcommerz_logo.9eda9e4d.svg";